import { Component, OnInit } from '@angular/core'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { FooterNavigationService } from '../../footer/footer-navigation.service'

@Component({
  standalone: false,
  selector: 'vs-video-tutor',
  templateUrl: './video-tutor.component.html',
  styleUrls: ['./video-tutor.component.scss'],
})
export class VideoTutorComponent implements OnInit {
  safeURL: any
  selectedHtmlElement: any
  displayVideo: boolean = true
  displayErrorMsg: boolean = false
  isValidURL: boolean

  constructor(
    private footerNavService: FooterNavigationService,
    private globalMessageService: GlobalMessageService
  ) {}

  ngOnInit(): void {
    this.footerNavService.videoLinkUrl.subscribe((data) => {
      this.safeURL = data['url']
      this.isValidURL = data['valid']

      if (!this.isValidURL) {
        this.displayErrorWarning()
      }
    })
  }

  displayErrorWarning() {
    this.globalMessageService.add(
      { key: 'help.issueDisplayVideo' },
      GlobalMessageType.MSG_TYPE_ERROR,
      5000
    )
    window.scrollTo(0, 0)
    this.closeSiteVideoOverlay()
  }

  closeSiteVideoOverlay() {
    this.footerNavService.openCloseVideoTourAction.next(false)
  }
}
